import { mapActions, mapGetters, mapState } from 'vuex';
import ls from '@/helpers/localStorage';

export const LS_MAINTENANCE_MESSAGE_KEY = 'maintenanceMessageHidden';

export default {
  computed: {
    ...mapGetters('app', ['hasBanner']),
    ...mapState('app', ['hasServerErrorOccurred', 'maintenance', 'liveUpdatesDisabled', 'hiddenMaintenanceMessage']),
    classModifiers() {
      return {
        'app-header-notification__wrapper': true,
      };
    },
    maintenanceMessageText() {
      return this.maintenance.suspendedMessage || this.maintenance.systemMessage;
    },
    hasServerMessage() {
      return !!this.maintenanceMessageText
        && this.maintenanceMessageText !== this.hiddenMaintenanceMessage;
    },
    showErrorNotification() {
      return !this.hasServerMessage && this.hasServerErrorOccurred;
    },
    showBannerNotification() {
      return !this.hasServerMessage && this.hasBanner && !this.hasServerErrorOccurred;
    },
  },
  methods: {
    ...mapActions('app', ['dontShowBanner', 'setServerError', 'setHiddenMaintenanceMessage']),
    onCloseMaintenanceMessage() {
      const expiresAt = 86400 * 3; // 3 days
      ls.set(LS_MAINTENANCE_MESSAGE_KEY, this.maintenanceMessageText, expiresAt);
      this.setHiddenMaintenanceMessage(this.maintenanceMessageText);
    },
    onErrorClick() {
      this.setServerError(false);
      const dt = new Date();
      this.$router.go({
        path: this.$router.path,
        query: {
          t: +dt,
        },
      });
    },
    onBannerClick() {
      this.dontShowBanner();
    },
    onSystemMessageClick() {
      this.$router.push({ name: 'platform-announcements' });
    },
  },
};



// WEBPACK FOOTER //
// ./src/components/app/app-header-notification/app-header-notification.js